export { default as MainImage1000 } from './MainImage1000';
export { default as MainImage768 } from './MainImage768';
export { default as MainImage360 } from './MainImage360';
